export const environment = {
  production: true,
  testing: false,
  API_URL: 'https://totalcareweb-api.kenbri.nl/api/',
  API_TOKEN_URL: 'https://totalcareweb-api.kenbri.nl/connect/token',
  ApiTokenEndpoint: 'https://totalcareweb-api.kenbri.nl/connect/token',
  ApiMfaEndpoint: 'https://totalcareweb-api.kenbri.nl/connect/mfa',
  whitelistedDomains: ['totalcareweb-api.kenbri.nl'],
  blacklistedRoutes: ['https://totalcareweb-api.kenbri.nl/connect/token'],
  DEFAULT_TOKEN_NAME: 'id_token',
  DEFAULT_REFRESH_TOKEN_NAME: 'refresh_token',
  environmentName: '',
};